if (!window.trustedTypes) {
  window.trustedTypes = {
    createPolicy: () => ({ createHTML: (s) => s }),
  };
}
